import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-image',
  templateUrl: './user-image.component.html',
  styleUrls: ['./user-image.component.css']
})
export class UserImageComponent implements OnInit {

  image = localStorage.getItem('userImage');

  constructor() { }

  ngOnInit() {

    setTimeout(() => {
      this.image = localStorage.getItem('userImage');
    },
      100);
  }

}
